var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import DOMPurify from "dompurify";
import QuestionnaireOrg from "../../../organisms/jsQuestionnaire/jsQuestionnaire";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { AdviserProgressionMilestoneAction, AdviserProgressionMilestoneFormAction, ResetAdviserGlobalFormAction, } from "../../../../redux/actions/adviser_questionnaire";
import { questionnaireTimer } from "../../../../utils/QuestionnaireTimer";
import { Status } from "../../../../redux/constants/status";
import { getAdviserQuestionnaireProgressWidth } from "../../../../utils/questionnaireProgress";
/**
 * The Adviser Progression Milestone Questionnaire Page
 * This will need to call all relevant APIs to get the values.
 * @param props
 * @returns
 */
function AdviserProgressionMilestoneQuestionnaire() {
    var navigate = useNavigate();
    var dispatch = useDispatch();
    var error = useState("")[0];
    //using selector hook to fetch data from the reducer
    var _a = useSelector(function (state) { return state.rootReducer.AdviserQuestionnaireReducer; }), adviserProgressionMilestoneData = _a.adviserProgressionMilestoneData, status = _a.status, adviserProgressionMilestoneFormData = _a.adviserProgressionMilestoneFormData, success_adviserProgressionMilestone_form = _a.success_adviserProgressionMilestone_form;
    useEffect(function () {
        questionnaireTimer.startSection("Progression Milestone");
        if (!adviserProgressionMilestoneData || adviserProgressionMilestoneData.length === 0) {
            dispatch(AdviserProgressionMilestoneAction());
        }
    }, [dispatch]);
    var loginData = useSelector(function (state) { return state.rootReducer.userReducer; }).loginData;
    // Get the viewing_username (the jobseeker being viewed by the adviser)
    var viewing_username = useSelector(function (state) { return state.rootReducer.dashboardReducer.viewing_username; });
    //function to submit the input user data
    var handleFormSubmit = function (formData) {
        questionnaireTimer.endSection("Progression Milestone");
        var timingData = questionnaireTimer.onQuestionnaireComplete();
        console.log("\u2705 Progression Milestone adviser questionnaire time: ".concat((timingData.totalSeconds / 60).toFixed(2), " minutes"));
        var sanitizedData = Object.keys(formData).reduce(function (acc, key) {
            acc[key] = DOMPurify.sanitize(formData[key]);
            return acc;
        }, {});
        var submissionData = __assign(__assign({}, sanitizedData), { completion_time_seconds: Math.round(timingData.totalSeconds) });
        dispatch(AdviserProgressionMilestoneFormAction(submissionData, loginData));
        questionnaireTimer.clearTimings();
    };
    var handleBackBtn = function () {
        dispatch(ResetAdviserGlobalFormAction());
        navigate("/questionnaire/adviserGlobal");
    };
    useEffect(function () {
        if (success_adviserProgressionMilestone_form) {
            navigate("/questionnaire/transition");
        }
    }, [success_adviserProgressionMilestone_form, navigate]);
    return (_jsxs("div", __assign({ className: "" }, { children: [error && _jsx("div", __assign({ className: "error-message" }, { children: error })), _jsx(QuestionnaireOrg, { title: "Progression Milestone", content: "", data: adviserProgressionMilestoneData, responses: adviserProgressionMilestoneFormData, loading: status === Status.Loading, handleSubmit: handleFormSubmit, handleBackBtn: handleBackBtn, classname: "global-w", width: getAdviserQuestionnaireProgressWidth("adviserProgressionMilestone", "milestone") })] })));
}
export default AdviserProgressionMilestoneQuestionnaire;
